var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo"},[(_vm.isTablet)?_c('PromoDelivery'):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"promo__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isDesktop)?_c('PromoImages'):_vm._e(),_vm._v(" "),_c('PromoBlocks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }